
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/map.htm",
      function () {
        return require("private-next-pages/map.htm/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/map.htm"])
      });
    }
  